import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { push } from "react-router-redux";
//utils
import { setUser } from "utils/auth";
//actions
import { actions } from "actions/resources";
//components
import LoginForm from "./forms/login";

export class AuthLogin extends Component {
  handleSubmit = async data => {
    const { createSession, redirect } = this.props;
    const response =  await createSession({
      email: data.email,
      password: data.password
    });

    if (response && response.admin) {
      await setUser(response);
      return redirect("/companies");
    }

    return redirect("/");
  };

  render() {
    return (
      <div className="auth-form">
        <LoginForm onSubmit={this.handleSubmit} />
      </div>
    );
  }
}

export default connect(
  null,
  dispatch => ({
    createSession: bindActionCreators(actions.createSession, dispatch),
    redirect: bindActionCreators(push, dispatch)
  })
)(AuthLogin);



// WEBPACK FOOTER //
// ./src/components/auth/login.js